/* Drop countdown for the hero's drop slide.
   Reads the moment off data-pk-drop, ticks once a second, and flips itself to
   a live state when the moment passes — so nobody has to swap the banner at
   5 PM. The "when" line writes itself from the target, so it can never go
   stale the way a hand-typed date would. */
(function () {
  'use strict';

  var TZ = 'Asia/Kolkata';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  /* The calendar date in IST, as YYYY-MM-DD. en-CA is the locale that yields
     that order, which makes the parts trivial to compare. */
  function istParts(date) {
    return new Intl.DateTimeFormat('en-CA', {
      timeZone: TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    })
      .format(date)
      .split('-')
      .map(Number);
  }

  /* Whole calendar days between two moments, counted in IST.

     This has to be a date comparison, not a duration one. Measuring the
     remaining seconds and dividing by 86400 says "0 days" for anything under
     24 hours — so a 5 PM drop seen at 7 PM the evening before reported
     "Today" when it is plainly tomorrow. */
  function daysApart(from, to) {
    var a = istParts(from);
    var b = istParts(to);
    return Math.round((Date.UTC(b[0], b[1] - 1, b[2]) - Date.UTC(a[0], a[1] - 1, a[2])) / 86400000);
  }

  function istTime(date) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZone: TZ
    }).formatToParts(date);
    var pick = function (k) {
      var f = parts.find(function (x) {
        return x.type === k;
      });
      return f ? f.value : '';
    };
    var mins = pick('minute');
    return pick('hour') + (mins && mins !== '00' ? ':' + mins : '') + ' ' + pick('dayPeriod').toUpperCase();
  }

  /* Today and Tomorrow while they are unambiguous; an explicit date after
     that, so it can never read as a vague "some weekday". */
  function whenLabel(target) {
    var diff = daysApart(new Date(), target);
    var day;
    if (diff === 0) day = 'Today';
    else if (diff === 1) day = 'Tomorrow';
    else {
      day = new Intl.DateTimeFormat('en-GB', {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        timeZone: TZ
      }).format(target);
    }
    return day + ' · ' + istTime(target) + ' IST';
  }

  function init(timer) {
    if (timer.dataset.ready) return;
    timer.dataset.ready = '1';

    var target = new Date(timer.dataset.pkDrop).getTime();
    if (!target || isNaN(target)) return;

    var lead = timer.querySelector('[data-drop-lead]');
    var when = timer.querySelector('[data-drop-when]');
    var d = timer.querySelector('[data-drop-d]');
    var h = timer.querySelector('[data-drop-h]');
    var m = timer.querySelector('[data-drop-m]');
    var s = timer.querySelector('[data-drop-s]');
    var liveLead = timer.dataset.liveLead || "It's live.";
    var liveWhen = timer.dataset.liveWhen || 'Shop the collection';
    var id = 0;

    function tick() {
      var left = target - Date.now();

      if (left <= 0) {
        timer.classList.add('is-live');
        if (lead) lead.textContent = liveLead;
        if (when) when.textContent = liveWhen;

        /* Point the banner at the collection now that it exists. Runs on a
           fresh load after the moment too, not just on a page that was left
           open through it — tick() fires once immediately on init. */
        var href = timer.dataset.liveHref;
        if (href) {
          var link = timer.closest('.pk-drop');
          if (link) link.setAttribute('href', href);
        }

        clearInterval(id);
        return;
      }

      var secs = Math.floor(left / 1000);
      if (d) d.textContent = pad(Math.floor(secs / 86400));
      if (h) h.textContent = pad(Math.floor((secs % 86400) / 3600));
      if (m) m.textContent = pad(Math.floor((secs % 3600) / 60));
      if (s) s.textContent = pad(secs % 60);

      if (!when) return;
      when.textContent = whenLabel(new Date(target));
    }

    tick();
    id = setInterval(tick, 1000);
  }

  function start() {
    document.querySelectorAll('[data-pk-drop]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  /* The theme editor re-renders the section on every edit. */
  document.addEventListener('shopify:section:load', start);
})();
